import { render, staticRenderFns } from "./planList.vue?vue&type=template&id=56f2fe7a&"
import script from "./planList.vue?vue&type=script&lang=js&"
export * from "./planList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports